import { call, put, takeEvery } from "redux-saga/effects";
import { addNotification } from "@fas/ui-framework";
import type { GetLinkingInfoSaga } from "../../actions/linkingList";
import { setLinkingInfo } from "../../actions/linkingList";
import { GET_LINKING_ITEM_SAGA, GET_LINKING_LOADING } from "../../helpers/constants";
import LinkingApi from "../../services/linkingApi";
import setLoading from "../../actions/loading";
import type { LinkingInfo } from "../../components/LinkingInfoForm/types/LinkingInfoForm.types";

export function* makeFetch(action: GetLinkingInfoSaga) {
  try {
    const { id } = action;
    yield put(setLoading(GET_LINKING_LOADING, true));

    const response: {
      data: {
        data: LinkingInfo,
      },
    } = yield call(LinkingApi.getLinkingInfo, id);
    const {
      data: { data: linkingInfo },
    } = response;
    yield put(setLinkingInfo(linkingInfo));
  }
  catch (error: any) {
    yield put(addNotification({ message: error.errorMessage || "Failed to fetch linking", severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
  }
  finally {
    yield put(setLoading(GET_LINKING_LOADING, false));
  }
}

export default function* watch() {
  yield takeEvery(GET_LINKING_ITEM_SAGA, makeFetch);
}
